import React from "react";
import { isUtenteSpeciale } from "./permessiProdotto";

const InputProdottoConAzioni = ({
  label,
  name,
  id,
  value,
  placeholder,
  onChange,
  inputClass,
  actionButtonClass,
  actions = [],
  copy = true,
}) => {
  const copyValue = (event) => {
    event.preventDefault();
    navigator.clipboard.writeText(value ?? "");
  };

  return (
    <div className="mb1">
      <label
        htmlFor={id}
        className={copy ? "pointer" : undefined}
        onClick={copy ? copyValue : undefined}
      >
        {label}
      </label>
      <div className="modificaProdottiInputRow mb2">
        <input
          type="text"
          id={id}
          name={name}
          value={value ?? ""}
          placeholder={placeholder}
          autoComplete="off"
          onChange={onChange}
          className={`${inputClass} modificaProdottiInput flex-auto br--left`}
          style={{ minWidth: 0 }}
        />
        {copy && (
          <button
            type="button"
            className={`${actionButtonClass} modificaProdottiInputAction`}
            onClick={copyValue}
            title={`Copia ${label.toLowerCase()}`}
            aria-label={`Copia ${label.toLowerCase()}`}
          >
            <span className="material-symbols-outlined">content_copy</span>
          </button>
        )}
        {actions.map(({ icon, label: actionLabel, onClick, disabled }) => (
          <button
            key={icon}
            type="button"
            className={`${actionButtonClass} modificaProdottiInputAction`}
            onClick={onClick}
            disabled={disabled}
            title={actionLabel}
            aria-label={actionLabel}
          >
            <span className="material-symbols-outlined">{icon}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

const formatEuro = (value) =>
  typeof value === "number" && Number.isFinite(value)
    ? value.toLocaleString("it-IT", { style: "currency", currency: "EUR" })
    : null;

// Prezzo WEB attivo (GET /moda/articoli/:codVS -> prezzoWeb): cartellino
// barrato e prezzo scontato in una riga. Il costo acquisto medio non è mai
// mostrato qui.
export function PrezzoWebRiga({ prezzoWeb }) {
  if (!prezzoWeb) return null;
  const cartellino = formatEuro(prezzoWeb.prezzoCartellino);
  const vendita = formatEuro(prezzoWeb.prezzoVendita);
  if (!vendita && !cartellino) return null;
  const scontato =
    cartellino && vendita && prezzoWeb.prezzoCartellino > prezzoWeb.prezzoVendita;
  return (
    <p className="mt3 mb2" aria-label="Prezzo WEB">
      <strong>Prezzo WEB:</strong>{" "}
      {scontato && <s className="gray mr2">{cartellino}</s>}
      <span className={scontato ? "b dark-red" : "b"}>{vendita ?? cartellino}</span>
    </p>
  );
}

function ColonnaDatiProdotto({
  prodottoTemp,
  utente,
  languages,
  lang,
  cambiaLingua,
  tastoQuadratoGiallo,
  tastoQuadratoVerde,
  tastoQuadratoBianco,
  alertSalvataggio,
  riquadroClassesRed,
  salvato,
  salvaSenzaChiudere,
  salvaProdotto,
  chiudiSenzaSalvare,
  buttonClassesGreen,
  buttonClassesRed,
  brandLimitazioniAlert,
  modaBrandNote,
  modaAnnullato,
  modaBrandDescription,
  modaBrandCode,
  modaArticolo,
  modaNomeColore,
  handleChange,
  inputClasses,
  inputClassesNOW,
  classiTastoCopiaInAlto,
  codProdModSuggerimento,
  codProdColSuggerimento,
  accettaSuggerimenti,
  checkCodProd,
  referenceSearchFeedback,
}) {
  const solaLettura = isUtenteSpeciale(utente);
  return (
    <div className="colonna1-l fl-l w-100 w-30-ns w-20-l pa2">
      <div className="colonna90vh sezioneConScroll pr2">
        <div className="flex justify-between">
          <span
            className="b pr2 f2 lh-title pointer pb2"
            onClick={(event) => {
              event.preventDefault();
              navigator.clipboard.writeText(prodottoTemp.codiceVS);
            }}
          >
            {prodottoTemp.codiceVS}
          </span>
          <div>
            {utente.permessiAPI["usage:googleapis"] &&
              languages.map((language) => (
                <button
                  key={`lang-${language}`}
                  name={language}
                  onClick={cambiaLingua}
                  className={
                    (language === lang && tastoQuadratoGiallo) ||
                    (prodottoTemp?.tradotto?.[language] &&
                      tastoQuadratoVerde) ||
                    tastoQuadratoBianco
                  }
                >
                  {language}
                </button>
              ))}
          </div>
        </div>

        {solaLettura && <div role="status" className="pa2 mb2 ba bordoColAlt scrittaColMedio">Sola lettura</div>}
        {alertSalvataggio && (
          <div role="alert" className={`${riquadroClassesRed} mb2`}>
            {alertSalvataggio}
          </div>
        )}
        {!salvato && (
          <button disabled={solaLettura} className={buttonClassesGreen} onClick={salvaSenzaChiudere}>
            Salva
          </button>
        )}
        {!salvato && (
          <button disabled={solaLettura} className={buttonClassesGreen} onClick={salvaProdotto}>
            Salva e chiudi
          </button>
        )}
        {!salvato && (
          <button className={buttonClassesRed} onClick={chiudiSenzaSalvare}>
            Chiudi senza salvare
          </button>
        )}
        {salvato && (
          <button className={buttonClassesGreen} onClick={chiudiSenzaSalvare}>
            Chiudi
          </button>
        )}

        {brandLimitazioniAlert && (
          <div className="mt3 mb3 pa3 br2 ba b--gold bg-washed-yellow dark-red">
            <strong>ATTENZIONE brand:</strong>{" "}
            {brandLimitazioniAlert.brandLabel || "brand MODA"}
            <br />
            {brandLimitazioniAlert.messages.join(" | ")}
          </div>
        )}
        {Array.isArray(modaArticolo?.tagModa) && modaArticolo.tagModa.length > 0 && (
          <div className="mt2 mb3 pa3 br2 ba b--gold bg-washed-yellow dark-gray">
            <strong>Tag Moda:</strong>{" "}
            {modaArticolo.tagModa
              .map((tag) => tag.description || tag.code)
              .join(", ")}
          </div>
        )}
        {modaBrandNote && (
          <div className="mt2 mb3 pa3 br2 ba b--light-silver bg-near-white dark-gray">
            <strong>Appunti brand:</strong>
            <br />
            {modaBrandNote}
          </div>
        )}
        {!prodottoTemp.codicePS && (
          <div className={`${riquadroClassesRed} mb3`}>
            <strong>ATTENZIONE:</strong> non è ancora presente l'id prestashop
            di questo prodotto. Probabilmente l'articolo non è ancora stato
            inviato dal gestionale verso il sito. Se lo pubblichi adesso non
            verrà messo in coda di sincronizzazione. Puoi lavorarci già adesso
            ma dovrai ripassare in un secondo momento, l'articolo verrà
            sincronizzato con il sito solo dopo aver salvato questa pagina
            senza questo avviso visibile. Se il problema persiste vuol dire che
            il gestionale non sta inviando questo articolo al sito: potrebbero
            esserci barcode doppi per una delle taglie, barcode non validi o
            altri motivi.
          </div>
        )}
        {modaAnnullato && (
          <div className="pa3 br2 bg-washed-red dark-red b mb3">
            ATTENZIONE! Questo articolo è annullato sul gestionale, e di
            conseguenza sarà disattivato su sito. Questa scheda è attiva solo
            per consultazione.
          </div>
        )}

        <p className="mb1">
          <strong>Brand MODA:</strong> {modaBrandDescription ?? "N/A"}
        </p>
        {modaArticolo && (
          <>
            <p className="mt1 mb0 f6 gray">
              Codice brand MODA: {modaBrandCode ?? "N/A"}
            </p>
            {modaNomeColore && (
              <p className="mt1 mb0 f6 gray">Colore: {modaNomeColore}</p>
            )}
          </>
        )}

        <div className="mt4">
          <InputProdottoConAzioni
            label="Codice produttore intero"
            name="codiceProduttore.codProduttoreIntero"
            id="codProduttoreIntero"
            value={prodottoTemp?.codiceProduttore?.codProduttoreIntero}
            placeholder=""
            onChange={handleChange}
            inputClass={inputClassesNOW}
            actionButtonClass={classiTastoCopiaInAlto}
            actions={[
              {
                icon: "content_cut",
                label: "Auto-splitta codice produttore",
                onClick: accettaSuggerimenti,
              },
            ]}
          />
          <InputProdottoConAzioni
            label="Codice produttore modello"
            name="codiceProduttore.codProduttoreModello"
            id="codProduttoreModello"
            value={prodottoTemp?.codiceProduttore?.codProduttoreModello}
            placeholder={codProdModSuggerimento}
            onChange={handleChange}
            inputClass={inputClassesNOW}
            actionButtonClass={classiTastoCopiaInAlto}
            actions={[
              {
                icon: "search",
                label: "Controlla se esistono altri prodotti",
                onClick: checkCodProd,
              },
            ]}
          />
          {referenceSearchFeedback && (
            <p className="f7 dark-red mt1 mb2">{referenceSearchFeedback}</p>
          )}
          <InputProdottoConAzioni
            label="Codice produttore colore"
            name="codiceProduttore.codProduttoreColore"
            id="codProduttoreColore"
            value={prodottoTemp?.codiceProduttore?.codProduttoreColore}
            placeholder={codProdColSuggerimento}
            onChange={handleChange}
            inputClass={inputClassesNOW}
            actionButtonClass={classiTastoCopiaInAlto}
          />
          <InputProdottoConAzioni
            label="Short name"
            name={`shortName.${lang}`}
            id="shortName"
            value={prodottoTemp.shortName?.[lang]}
            placeholder=""
            onChange={handleChange}
            inputClass={inputClassesNOW}
            actionButtonClass={classiTastoCopiaInAlto}
          />
          <InputProdottoConAzioni
            label="Titolo"
            name={`descrizioniSuPS.titolo.${lang}`}
            id="titolo"
            value={prodottoTemp.descrizioniSuPS.titolo[lang]}
            placeholder=""
            onChange={handleChange}
            inputClass={inputClassesNOW}
            actionButtonClass={classiTastoCopiaInAlto}
          />
        </div>

        {prodottoTemp?.descrizioniSuPS?.descBreve?.[lang] ? (
          <label
            htmlFor="descBreve"
            className="pointer"
            onClick={(event) => {
              event.preventDefault();
              navigator.clipboard.writeText(
                prodottoTemp.descrizioniSuPS.descBreve[lang],
              );
            }}
          >
            Descrizione breve
          </label>
        ) : (
          <label htmlFor="descBreve">Descrizione breve</label>
        )}
        <div>
          <textarea
            rows="6"
            cols="50"
            id="descBreve"
            name={`descrizioniSuPS.descBreve.${lang}`}
            value={prodottoTemp?.descrizioniSuPS?.descBreve?.[lang] ?? ""}
            onChange={handleChange}
            className={inputClasses}
          />
        </div>

        <InputProdottoConAzioni
          label="Url pagina ufficiale"
          name="url_pagina_uff"
          id="url_pagina_uff"
          value={prodottoTemp?.url_pagina_uff}
          placeholder="https://"
          onChange={handleChange}
          inputClass={inputClassesNOW}
          actionButtonClass={classiTastoCopiaInAlto}
          copy={false}
          actions={[
            {
              icon: "open_in_new",
              label: "Apri pagina ufficiale",
              disabled: !prodottoTemp?.url_pagina_uff,
              onClick: (event) => {
                event.preventDefault();
                window.open(
                  prodottoTemp.url_pagina_uff,
                  "_blank",
                  "noopener,noreferrer",
                );
              },
            },
          ]}
        />
        <PrezzoWebRiga prezzoWeb={modaArticolo?.prezzoWeb} />
      </div>
    </div>
  );
}

export default ColonnaDatiProdotto;
